import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { analyticsCardErrorClickDone } from '@perpay-web/fintech/actions/analytics/cardOnboardingMVP2';
import CardApplicationError from '@perpay-web/fintech/components/composite/CardApplicationError/CardApplicationError';
import { paths } from '@perpay-web/fintech/props/appPaths';

const CardApplicationErrorContainer = ({ isPHO = false }) => {
    const dispatch = useDispatch();

    const onClickDone = useCallback(
        () => dispatch(analyticsCardErrorClickDone()),
        [dispatch],
    );

    const dashboardURL = isPHO
        ? `${paths.dashboard.path}?PHO_complete=true`
        : paths.dashboard.path;

    return (
        <CardApplicationError
            onClickDone={onClickDone}
            dashboardURL={dashboardURL}
        />
    );
};

export default CardApplicationErrorContainer;
